import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { useRecoilValue } from "recoil";
import { previewState } from "../../../atoms/quote/preview-state";
import { CustomCell } from "../CustomCell";
import { PartnerOrderItemTableFooter } from "./PartnerOrderItemTableFooter";
import { PartnerOrderItemTableRow } from "./PartnerOrderItemTableRow1";

const headers: TableHeader[] = [
  { title: "No", width: "w-[48px]", align: "flex justify-center" },
  { title: "상품", width: "w-[720px]" },
  { title: "수량", width: "w-[160px]" },
  { title: "기본 할인", width: "w-[240px]" },
  { title: "인센티브 할인", width: "w-[240px]" },
  { title: "판매 금액 (VAT 포함)", width: "w-[240px]" },
];
export const PartnerOrderItemTable = () => {
  const preview = useRecoilValue(previewState);

  return (
    <div className="overflow-x-auto border rounded-lg">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {preview?.cartItems.map((item, index) => (
            <PartnerOrderItemTableRow key={index} data={item} index={index} />
          ))}
          <PartnerOrderItemTableFooter
            headersLength={Object.values(headers).length}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
